module.exports = __webpack_public_path__ + "static/img/ybp.542092f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cockpitCh/ybp.png
// module id = aVrM
// module chunks = 31